/**
 * Wrap a submit handler so the event stops at this form.
 *
 * Both contact modals render inside a page that has its own click handling, so
 * a nested form's submit must not bubble out of the modal.
 */
const stopPropagate =
  (callback: () => void) => (e: { stopPropagation: () => void; preventDefault: () => void }) => {
    e.stopPropagation()
    callback()
    e.preventDefault()
  }

export default stopPropagate
